import { createFileRoute } from '@tanstack/react-router'
import { StateModelEditPage } from '@/pages/settings/state-model-editor/state-model-edit-page'
import { WorkspaceEntitlementGate } from '@/features/workspace-entitlements/ui/workspace-entitlement-gate'
import { WorkspaceEntitlementKey } from '@/graphql/schema'

export const Route = createFileRoute('/settings/state-models_/$id/edit')({
  component: () => (
    <WorkspaceEntitlementGate
      feature={WorkspaceEntitlementKey.StateModelConfiguration}
    >
      <StateModelEditPage />
    </WorkspaceEntitlementGate>
  ),
})
